var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumanremains1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17429_18463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 28.5C13 31.9995 15.1 39 23.5 39C23.5 35.5005 21.4 28.5 13 28.5ZM17.5 19.5V13.5L21.25 16.5L25 12L28.75 16.5L32.5 13.5V19.5C32.5 22.0005 31 27 25 27C19 27 17.5 22.0005 17.5 19.5ZM37 28.5C37 31.9995 34.9 39 26.5 39C26.5 35.5005 28.6 28.5 37 28.5Z",
    fill: "#020C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 39C15.1 39 13 31.9995 13 28.5C21.4 28.5 23.5 35.5005 23.5 39ZM23.5 39H25H23.5ZM25 39V27V39ZM25 39H26.5H25ZM25 27C19 27 17.5 22.0005 17.5 19.5V13.5L21.25 16.5L25 12L28.75 16.5L32.5 13.5V19.5C32.5 22.0005 31 27 25 27ZM26.5 39C34.9 39 37 31.9995 37 28.5C28.6 28.5 26.5 35.5005 26.5 39Z",
    fill: "#020C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 39C15.1 39 13 31.9995 13 28.5C21.4 28.5 23.5 35.5005 23.5 39ZM23.5 39H25M25 39V27M25 39H26.5M25 27C19 27 17.5 22.0005 17.5 19.5V13.5L21.25 16.5L25 12L28.75 16.5L32.5 13.5V19.5C32.5 22.0005 31 27 25 27ZM26.5 39C34.9 39 37 31.9995 37 28.5C28.6 28.5 26.5 35.5005 26.5 39Z",
    stroke: "#020C41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 0C11.1667 0 0 11.1667 0 25C0 38.8333 11.1667 50 25 50C38.8333 50 50 38.8333 50 25C50 11.1667 38.8333 0 25 0ZM43.3333 25C43.3333 28.8333 42.1667 32.4167 40.0833 35.4167L14.5833 9.91667C17.5833 7.83333 21.1667 6.66667 25 6.66667C35.1667 6.66667 43.3333 14.9167 43.3333 25ZM6.66667 25C6.66667 21.1667 7.83333 17.5833 9.91667 14.5833L35.4167 40.0833C32.4167 42.1667 28.8333 43.3333 25 43.3333C14.9167 43.3333 6.66667 35.0833 6.66667 25Z",
    fill: "#FA0073"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17429_18463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanremains1);
export default __webpack_public_path__ + "static/media/humanremains1.e9d6fa554e0c37b006f75bbc62545ac5.svg";
export { ForwardRef as ReactComponent };